import { render } from "./SingleFileUploadComponent.vue?vue&type=template&id=665e2e74&scoped=true"
import script from "./SingleFileUploadComponent.vue?vue&type=script&lang=js"
export * from "./SingleFileUploadComponent.vue?vue&type=script&lang=js"

import "./SingleFileUploadComponent.vue?vue&type=style&index=0&id=665e2e74&lang=scss&scoped=true"

import exportComponent from "/workspace/source/scm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665e2e74"]])

export default __exports__